import React, { createContext, useEffect, useState } from 'react';
import { IsLoggedIn, Logout, SetUserLocalStorage } from "../utils";
// import { fakeAuthProvider } from '../auth';

interface AuthContextType {
  user: any;
  signin: (user: { [x: string]: any }, callback: VoidFunction) => void;
  signout: (callback: VoidFunction) => void;
}

export const AuthContext = createContext<AuthContextType>(null!);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<any>(IsLoggedIn());

  const signin = (newUser: { [x: string]: any }, callback: VoidFunction) => {
    //   return fakeAuthProvider.signin(() => {
    //     setUser(newUser);
    //     callback();
    //   });
    SetUserLocalStorage(newUser)
    setUser(newUser);
    callback();
  };

  const signout = (callback: VoidFunction) => {
    Logout(callback)                      
    setUser(null);
  };

  useEffect(() => {
    const isLog = IsLoggedIn();
    if(isLog) {
     setUser(IsLoggedIn())
    }
  }, []);

  // console.log('AuthProvider')

  const value = { user, signin, signout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
export default AuthProvider;
